// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"lE-z","smallCardRow":"mE-z","largeCardRow":"nE-z","productSearchRow":"oE-z","curatedRow":"pE-z"};